import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';
import { formatMediumDate } from '../dateHelpers';
import { Modes } from '../Constants';
import TranslationService from '../../translations';

const isToday = (date) => {
  date.setHours(0, 0, 0, 0);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  if (date.getTime() === currentDate.getTime()) {
    return true;
  }

  return false;
};

const DateComponent = ({ lastUpdatedDateInUtc, createdDateInUtc, context }) => {
  const { homePage } = Classes;
  const translations = TranslationService.getTranslations(context.interfaceLocale);
  const dateToShow = lastUpdatedDateInUtc || createdDateInUtc;
  const isUpdated = !!lastUpdatedDateInUtc;

  const classNameToday = isUpdated ? homePage.participantItem.updatedDate : homePage.participantItem.createdDate;
  const dateTodayText = isUpdated ? translations.directory.updatedTodayText : translations.directory.createdTodayText;
  const classNameOn = isUpdated ? homePage.participantItem.updatedDateOn : homePage.participantItem.createdDateOn;
  const dateOnText = isUpdated ? translations.directory.updatedText : translations.directory.createdText;

  let localDate;
  let isDateToday;
  if (dateToShow) {
    // 0001-01-01T00:00:00
    localDate = new Date(`${dateToShow}Z`);
    isDateToday = isToday(localDate);
  }

  return (dateToShow && context.mode !== Modes.private ? (
    <div className={homePage.participantItem.dateComponentClass} data-testid="dateComponent">
      {isDateToday
        ? <div className={classNameToday}>{dateTodayText}</div>
        : (
          <div
            data-testid="dateComponentOn"
            className={classNameOn}
          >
            {dateOnText}
            {' '}
            {formatMediumDate(localDate.toISOString())}
          </div>
        )}
    </div>
  ) : null);
};

DateComponent.propTypes = {
  createdDateInUtc: PropTypes.string.isRequired,
  lastUpdatedDateInUtc: PropTypes.string.isRequired
}.isRequired;

export default DateComponent;
